// extracted by mini-css-extract-plugin
export default {"theme_toggle_section":"Theme_toggle_theme_toggle_section__EwIG7","theme_button_img":"Theme_toggle_theme_button_img__Tj3G2"};